import moment from 'moment-timezone';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body, Caption } from 'src/components';
import { Size } from 'src/constants';
import { useReminders } from 'src/hooks';
import { Weight } from 'src/theme';
import { HeaderRow, RightSectionContainer, RightSectionDataContainer, TableRow } from './style';
import { toLocalShortDate } from 'src/utils';
import { Bell } from 'react-native-feather';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import _ from 'lodash';

interface Props {
  patientId: string;
}

const MedicalReminders: React.FC<Props> = ({ patientId }) => {
  const { t } = useTranslation('petID');
  const { colors } = useAppTheme();
  const { data: reminders } = useReminders();

  const filteredReminders = reminders.filter((r) => r.patientId === patientId);

  return (
    <RightSectionContainer>
      <HeaderRow>
        <Bell color={colors.onSurface} height={Size.S} width={Size.S} />
        <Body fontWeight={Weight.MEDIUM}>{t('medicalReminders')}</Body>
      </HeaderRow>
      <RightSectionDataContainer>
        {!filteredReminders.length && <Caption>{t('none')}</Caption>}
        {!!filteredReminders?.length && (
          <TableRow>
            <Caption fontWeight={Weight.MEDIUM}>
              {_.toUpper(t('patientProfile:description'))}
            </Caption>
            <Caption fontWeight={Weight.MEDIUM}>{_.toUpper(t('dueDate'))}</Caption>
          </TableRow>
        )}
        {!!filteredReminders?.length &&
          filteredReminders.map((reminder, i) => {
            return (
              <TableRow key={i}>
                <Caption numberOfLines={1}>{reminder.description}</Caption>
                <Caption>{toLocalShortDate(moment(reminder.pastDueDate))}</Caption>
              </TableRow>
            );
          })}
      </RightSectionDataContainer>
    </RightSectionContainer>
  );
};

export default MedicalReminders;
